import React from 'react';

import { Column, TColumnProps } from 'app/components/Column';

export const PageTemplate: React.FC<TColumnProps> = ({ children, ...columnProps }) => (
  <Column maxWidth='1200px' margin='0 auto' px={['10px', 0]} {...columnProps}>
    {children}
  </Column>
);
